<template>
  <table class = "table table-striped table-hover">
    <thead>
    <tr>
      <slot name = "header" />
    </tr>
    </thead>
    <tbody @keydown.up = "selectPreviousRow" @keydown.down = "selectNextRow">
    <slot :active-row = "activeRow" />
    </tbody>
  </table>
</template>
<script lang = "babel">
  export default{
    name: 'SelectableGrid',

    props: {
      rows: Number,
      focused: Boolean
    },

    data () {
      return {
        selectedRow: null
      }
    },

    computed: {
      activeRow () {
        if (!this.focused) {
          return null
        } else {
          return this.selectedRow
        }
      }
    },

    watch: {
      focused (value) {
        if (value) {
          this.selectedRow = 0
        }
      }
    },

    methods: {
      selectNextRow () {
        if (this.selectedRow < this.rows - 1) {
          this.selectedRow += 1
        }
      },

      selectPreviousRow () {
        if (this.selectedRow > 0) {
          this.selectedRow -= 1
        }
      }
    },

    created () {
      this.$on('activated', (data) => {
        this.selectedRow = data.row
      })
    }
  }
</script>



// WEBPACK FOOTER //
// SelectableGrid.vue?3fd38830